/*
 * @Description: 系统设置-用户管理-API
 */

/*
 * @Description: 系统设置-角色管理-API
 */

import { clearFalseValue, formatTableGetParams, formatTableResponse } from '@/utils/utils';
import { httpRequest } from '@/utils/umiRequest';

//获取全部部门
export async function fetchDepartments(options?: Record<string, any>) {
  return httpRequest.get('/departments', {}, options);
}

//删除部门
export async function deleteDepartments({ id }: { id: number }, options?: Record<string, any>) {
  return httpRequest.delete(`/departments/${id}`, {}, options);
}

/**
 *
 * @description 根据用户id获取指定level级别的部门
 * @param {number} id
 * @param {number} level
 * @return {*}  {Promise<any>}
 */
export function getDepartmentByLevel(id: number, level: number): Promise<any> {
  return httpRequest.get(`/users/${id}/department-level/${level}`);
}

//创建部门
export async function createDepartments(
  data: { parent_id: number; name: string },
  options?: Record<string, any>,
) {
  return httpRequest.post('/departments', data, options);
}

// 编辑组织架构
export async function editDepartmentsAPI(
  id: number,
  data: { name: string },
  options?: Record<string, any>,
) {
  return httpRequest.put(`/departments/${id}`, data, options);
}
